module.exports = __webpack_public_path__ + "static/media/mbaImage.ccff80d6.png";